export default __webpack_public_path__ + "59b4b4d830cc2a8d6f28590e9e7de4fa.svg";